import React from 'react';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  DigitalEventsControlUnits,
  SensordataNewest,
} from '../../monitoring/api/monitoring.model';
import { Base64 } from '../../../util/Base64';
import { arrayToRecord } from '../../../util/ArrayUtil';
import {
  ControlUnitAPIResponse,
  LinkedDigitalEvent,
  LinkedDigitalSensorData,
} from './ControlUnit.model';
import _ from 'lodash';
import { RecordLVL2 } from '../../../util/types/Records';
import { ControlUnitAdapter } from './adapter/CommanderStatusAdapter';
import Util from '../../../util/Util';

const ControlUnitBaseURL = new Util().getCommanderManagementURL();
const SensorDataBaseURL = new Util().getSensorDataServiceURL();
const EventDataBaseURL = new Util().getEventServiceURL();

const ControlUnitAPI = createApi({
  reducerPath: 'ControlUnitAPI',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['control-unit', 'commander'],
  // One day
  keepUnusedDataFor: 24 * 60 * 60,
  endpoints(build) {
    return {
      getControlUnitById: build.query({
        query: (deviceId: string) => ({
          url: `${ControlUnitBaseURL}/${Base64.encode(deviceId)}/controlunits`,
        }),
        transformResponse: (response: ControlUnitAPIResponse[]) => {
          return ControlUnitAdapter.setAll(
            ControlUnitAdapter.getInitialState(),
            response
          );
        },
        providesTags: (_result, _error, arg) => [
          { type: 'commander' as const, id: arg },
          'control-unit',
        ],
      }),
      // Volatile data
      getCurrentSensorDataByCommanderID: build.query<
        LinkedDigitalSensorData,
        string
      >({
        query: (deviceId) => ({
          url: `${SensorDataBaseURL}/${Base64.encode(deviceId)}/newest`,
        }),
        transformResponse: (response: SensordataNewest[]) => {
          return response.reduce((acc, currentItem) => {
            _.setWith(
              acc,
              [currentItem.cuId, currentItem.channel],
              currentItem,
              Object
            );
            return acc;
          }, {}) as LinkedDigitalSensorData;
        },
        providesTags: (result, error, arg) => [
          { type: 'commander' as const, id: arg },
        ],
      }),
      getCurrentEventsByCommanderID: build.query<LinkedDigitalEvent, string>({
        query: (deviceId) => ({
          url: `${EventDataBaseURL}/${Base64.encode(deviceId)}/newest`,
        }),
        providesTags: (result, error, arg) => [
          { type: 'commander' as const, id: arg },
        ],
        transformResponse: (response: DigitalEventsControlUnits[]) => {
          return arrayToRecord(response, 'idCU', (cuEvents) =>
            arrayToRecord(cuEvents.events, 'eventID')
          );
        },
      }),
      getControlUnitsBySerialNumber: build.query({
        query: (serialNumber) => ({
          url: `${ControlUnitBaseURL}/serialnum/${serialNumber}/controlunits`,
        }),
        providesTags: (result, error, arg) => [
          { type: 'commander' as const, id: arg },
        ],
      }),
    };
  },
});
export default ControlUnitAPI;
